function getMessages()
{
  let $friend = getActiveFriend();

  if ($friend.length > 0) {
    initMessageList();

    let functionParams = {
      user_id_to: $friend.data("id")
    };

    let ajaxParams = {
      onSuccess: function (response) {
        createMessageElements(response);
        setMessagesRead();
      }
    };

    App.Helper.ajaxCall('messages_private', functionParams, ajaxParams);
  }
}

function setMessagesRead()
{
  if ($("#messageList .message.friend.unread").length > 0) {
    let messageIds = [];
    $("#messageList .message.friend.unread").each(function()
    {
      messageIds.push($(this).data("id"))
    });

    let functionParams = {
      messageIds: messageIds
    };

    App.Helper.ajaxCall('set_messages_private_read', functionParams, {});
  }
}

function getActiveFriend()
{
  return $(".friend.active");
}

function initMessageList()
{
  $("#txtaMessage").prop("disabled", false);
  $("#btnMessage").prop("disabled", false);
}

function createMessageElements(response)
{
  let $list = $("#messageList");
  $list.empty();

  let messages = $.parseJSON(response.content);

  $.each(messages, function(key, message)
  {
    let className = parseInt(message.user_id_from) === USER_ID ? "me" : "friend";
    if (message.read === null) {
      className += ' unread';
    }
    
    let $message = $('<div class="message ' + className + '" data-id="' + message.id + '"></div>');
    $list.append($message);
    $message.text(message.text);
    let $timestamp = $('<small class="time text-muted"></small>')
    $timestamp.text(message.created_at_formatted);
    $message.append($timestamp);
  });

  if (messages.length === 0) {
    $list.append('<p>' + App.Lang.get("no_messages_yet") + '</p>');
  }
}

function sendMessage()
{
  let $btn = $("#btnMessage");
  let $friend = getActiveFriend();

  if ($friend.length > 0) {
    let functionParams = {
      user_id_to: $friend.data("id"),
      message: $.trim($("#txtaMessage").val())
    };

    let ajaxParams = {
      sourceEl: $btn,
      effectTarget: $btn,
      onSuccess: function (response) {
        $("#txtaMessage").val("");
        initMessageList();
        createMessageElements(response);
      }
    };

    App.Helper.ajaxCall('send_message_private', functionParams, ajaxParams);
  }
}

$(document).ready(function()
{
  if ($("#conMessages").length > 0)
  {
    $(".friend").on("click", function()
    {
      let $friend = $(this);

      $(".friend").removeClass("active");
      $friend.addClass("active");

      getMessages();
    });

    $("#btnMessage").on("click", function()
    {
      sendMessage();
    });
    $("#txtaMessage").keydown(function (e) {
      if (e.ctrlKey && e.keyCode === 13) {
        sendMessage();
      }
    });

    window.setInterval(function() {
      getMessages();
    }, 5000);
  }
});
